import {
  VStack,
  FormControl,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputLeftAddon,
  Button,
  Stack,
  Text,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  InputRightAddon,
  Link,
  IconButton,
} from '@chakra-ui/react'
import { useContext, useState } from 'react'
import { shortAddress } from '../../utils/minorUtils'
import { usePrepareContractWrite, useContractWrite, useWaitForTransaction, useBalance } from 'wagmi'
import SplitPayServerABI from '../../assets/constants/abi/SplitPayServer.json'
import NetworkMapping from '../../assets/constants/network-mapping.json'
import { SplitPayContext } from '../../context/SplitPayContext'
import { ethers } from 'ethers'
import { ArrowLeftIcon } from '@chakra-ui/icons'

const PaymentPage = () => {
  const { splitState, previousForm } = useContext(SplitPayContext)
  const [releaseAddress, setReleaseAddress] = useState('')
  const [amount, setAmount] = useState('')

  const { data: contractBalance } = useBalance({
    address: splitState.contractAddress,
    watch: true,
  })

  const { config: addFundsConfig } = usePrepareContractWrite({
    address: NetworkMapping['80001']['SplitPayServer'] as `0x${string}`,
    abi: SplitPayServerABI,
    functionName: 'fundContract',
    args: [splitState.splitId],
    enabled: !!amount,
    overrides: {
      value: ethers.utils.parseEther(amount || '0'),
    },
  })

  const {
    data: addFundsData,

    write: addFunds,
  } = useContractWrite(addFundsConfig)

  useWaitForTransaction({
    hash: addFundsData?.hash,
  })

  const { config: releaseConfig } = usePrepareContractWrite({
    address: NetworkMapping['80001']['SplitPayServer'] as `0x${string}`,
    abi: SplitPayServerABI,
    functionName: 'releaseShare',
    args: [splitState.splitId, releaseAddress],
    enabled: true,
  })

  const {
    data: releaseData,

    write: release,
  } = useContractWrite(releaseConfig)

  useWaitForTransaction({
    hash: releaseData?.hash,
  })

  const { config } = usePrepareContractWrite({
    address: NetworkMapping['80001']['SplitPayServer'] as `0x${string}`,
    abi: SplitPayServerABI,
    functionName: 'distribute',
    args: [splitState.splitId],
    enabled: true,
  })

  const { data, write: distribute } = useContractWrite(config)

  useWaitForTransaction({
    hash: data?.hash,
  })

  return (
    <>
      <IconButton
        aria-label="back"
        icon={<ArrowLeftIcon />}
        float={{ base: 'initial', md: 'left' }}
        onClick={previousForm}
      />
      <VStack>
        <Stack>
          <Heading fontSize={'lg'} textAlign={'center'}>
            <Link
              href={`https://mumbai.polygonscan.com/address/${splitState.contractAddress}`}
              target="_blank"
            >
              Split Id: {splitState.splitId}
            </Link>
          </Heading>
          <Text textAlign={'center'}>
            Balance: {contractBalance?.formatted} {contractBalance?.symbol}
          </Text>
        </Stack>
        <Stack>
          <FormControl>
            <FormLabel color={'teal'} fontWeight="bold">
              Amount
            </FormLabel>
            <InputGroup>
              <Input
                placeholder="0.1"
                _placeholder={{ color: 'gray.500' }}
                type="text"
                onChange={(e) => setAmount(e.target.value)}
                value={amount}
                maxW={'md'}
              />
              <InputRightAddon children="MATIC" />
            </InputGroup>
          </FormControl>
          <Button
            onClick={(e) => {
              e.preventDefault()
              addFunds?.()
            }}
          >
            Fund Contract
          </Button>
          <FormControl>
            <FormLabel color={'teal'} fontWeight="bold">
              Recipient Address
            </FormLabel>
            <InputGroup>
              <InputLeftAddon children="0x" />
              <Input
                placeholder="Enter Recipient Address"
                _placeholder={{ color: 'gray.500' }}
                type="text"
                onChange={(e) => setReleaseAddress(e.target.value)}
                value={releaseAddress}
                maxW={'md'}
              />
            </InputGroup>
          </FormControl>
          <Button
            onClick={(e) => {
              e.preventDefault()
              release?.()
            }}
          >
            Release Funds
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault()
              distribute?.()
            }}
          >
            Distribute
          </Button>
        </Stack>
        <Stack>
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Recipient [{splitState.recipients.length}]</Th>
                  <Th>Share [{splitState.totalShares}]</Th>
                  <Th> Released [{splitState.totalReleased}]</Th>
                </Tr>
              </Thead>
              <Tbody>
                {splitState.recipients.map((recipient: any, idx: any) => {
                  return (
                    <Tr key={recipient}>
                      <Td>{shortAddress(recipient)}</Td>
                      <Td>
                        {splitState.shares[idx]}[
                        {(splitState.shares[idx] / splitState.totalShares) * 100} % ]
                      </Td>
                      <Td>{splitState.amountReleased[idx]}</Td>
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Stack>
      </VStack>
    </>
  )
}
export default PaymentPage
